module.exports = __webpack_public_path__ + "static/media/cybereffect.4d1966af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/books/cybereffect.jpg
// module id = 305
// module chunks = 0